import { ComponentProps } from 'react';

import { css, styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

import { BaseAnswer, RegularAnswerProps } from '~/blocks/TestCard/TestCard';
import { BIG_RADIUS_PX, SMALL_MARGIN_PX } from '~/theme';

const lefBubbleCss = css`
  margin: 0;
  padding: ${SMALL_MARGIN_PX};
  border-radius: ${BIG_RADIUS_PX} ${BIG_RADIUS_PX} ${BIG_RADIUS_PX} 0;
  font-size: 14px;
`;
export const LeftBubble = styled(motion.p, {
  shouldForwardProp: (prop) =>
    prop !== 'selected' && prop !== 'passed' && prop !== 'failed' && prop !== 'finished',
})<Omit<RegularAnswerProps, 'colorsMode'>>`
  ${lefBubbleCss};
  background: ${({ theme }) => theme.palette.common.card.background.light};
  border: 2px solid ${({ theme }) => theme.palette.common.card.background.light};
`;
export const RightBubble = styled(BaseAnswer)<ComponentProps<typeof motion.p>>`
  ${lefBubbleCss};
  border-radius: ${BIG_RADIUS_PX} ${BIG_RADIUS_PX} 0 ${BIG_RADIUS_PX};
  text-align: left;
`;
